import React from 'react';
import { useSectionAnimation } from '../hooks/useInViewAnimation';

export default function FadeInSection({ children, id }) {
  const [ref, inView] = useSectionAnimation();

  return (
    <section
      ref={ref}
      id={id}
      className={`fade-in-section ${inView ? 'is-visible' : ''}`}
    >
      {children}
    </section>
  );
}
